import { ICode } from '@src/model/common/Code';

export interface IUserStatus extends ICode<UserStatusEnum> {}

export enum UserStatusEnum {
  ACTIVE = '1',
  INACTIVE = '2',
  PARTIAL = '3',
}
